import React, { useEffect } from "react";
import { LegalShell, Section } from "./LegalShell";

export default function ImpressumPage() {
  useEffect(() => {
    document.title = "Plantus · Impressum";
  }, []);
  return (
    <LegalShell title="Impressum" lastUpdated="Februar 2026" testId="impressum-page">
      <Section title="Angaben gemäß § 5 TMG">
        <p>
          <strong>Hoytec-Solutions</strong>
          <br />
          Inhaber: René Hoyer
          <br />
          Neusornziger Straße 9
          <br />
          04769 Mügeln
          <br />
          Deutschland
        </p>
      </Section>

      <Section title="Kontakt">
        <p>
          Telefon: <a href="tel:+4901735993152" className="text-forest-700 hover:underline">+49 173 5993152</a>
          <br />
          E-Mail:{" "}
          <a href="mailto:info@plantus-app.com" className="text-forest-700 hover:underline">
            info@plantus-app.com
          </a>
        </p>
      </Section>

      <Section title="Umsatzsteuer-Identifikationsnummer">
        <p>
          Gemäß § 27 a Umsatzsteuergesetz:
          <br />
          <strong>DE463222118</strong>
        </p>
      </Section>

      <Section title="Steuernummer">
        <p>239/233/00686</p>
      </Section>

      <Section title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
        <p>
          René Hoyer
          <br />
          Neusornziger Straße 9
          <br />
          04769 Mügeln
        </p>
      </Section>

      <Section title="EU-Streitschlichtung">
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noreferrer"
            className="text-forest-700 hover:underline"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          .
          <br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </Section>

      <Section title="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Section>

      <Section title="Haftung für Inhalte">
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach
          den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
          jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
          allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
          erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
          Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
          entfernen.
        </p>
      </Section>

      <Section title="Haftung für Links">
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
          Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
          Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich.
        </p>
      </Section>

      <Section title="Urheberrecht">
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
          dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
          der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
          Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>
      </Section>
    </LegalShell>
  );
}
